import { Button, Modal, Text } from "../../../components";
import { AlarmListLayout, AuthLayout } from "../../../layouts";
import Localization from "../../../localization";
import React from "react";

const AlarmList = ({ refs = {}, next = () => {}, subscribe = () => {} }) => {
  return (
    <React.Fragment>
      <Text
        level={4}
        weight={"700"}
        color="secondary"
        className="m-30-b"
        children={Localization.purchase.alarm_list_title}
      />
      <AlarmListLayout
        renderFooter={(device) => (
          <Button
            type="primary"
            className="m-40-t"
            title={Localization.general.next}
            onClick={async () => next(device)}
            disabled={!device.uuid || device.integration === "other"}
          />
        )}
      />
      <Modal
        width={550}
        closeable={false}
        ref={refs.successModal}
        title={Localization.purchase.success_title}
        child={() => (
          <Modal.Success
            desc={Localization.purchase.success_desc}
            button={{
              onClick: subscribe,
              title: Localization.general.continue,
            }}
          />
        )}
      />
      <AuthLayout
        ref={refs.authLayout}
        onAuthComplete={(data) => next({ ...data, authenticated: true })}
      />
    </React.Fragment>
  );
};

export default AlarmList;
